import React from 'react';

const DetailsField = ({ formData, handleInputChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="details">Details <span className="optional">(Optional)</span></label>
      <textarea id="details" name="details" value={formData.details} onChange={handleInputChange}></textarea>
    </div>
  );
};

export default DetailsField;
